import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  TextField,
} from "@mui/material";
import { useState } from "react";
import documentoService from "../services/documento";

const AdicionarDocumentoModal = ({
  open,
  onClose,
  onDocumentoAdicionado,
  processoSelecionado,
  tipo = "solicitacao",
}) => {
  const [novoDocumento, setNovoDocumento] = useState({
    nomeDoArquivo: "",
    descricao: "",
  });
  const [uploading, setUploading] = useState(false);

  const handleFechar = () => {
    setNovoDocumento({
      nomeDoArquivo: "",
      descricao: "",
    });
    onClose();
  };

  const handleAdicionarDocumento = async () => {
    if (!novoDocumento.nomeDoArquivo?.trim()) {
      alert("O nome do arquivo é obrigatório.");
      return;
    }

    if (!novoDocumento.descricao?.trim()) {
      alert("A descrição é obrigatória.");
      return;
    }

    if (!processoSelecionado?.id) {
      alert("Nenhuma solicitação selecionada.");
      return;
    }

    try {
      setUploading(true);

      if (tipo === "protocolo") {
        await documentoService.criarDocumentoProtocolo(
          processoSelecionado.id,
          novoDocumento.nomeDoArquivo.trim(),
          novoDocumento.descricao.trim() || "",
        );
        const documentos = await documentoService.obterDocumentosPorProtocolo(
          processoSelecionado.id,
        );
        onDocumentoAdicionado(documentos.data || []);
      } else {
        await documentoService.criarDocumento(
          processoSelecionado.id,
          novoDocumento.nomeDoArquivo.trim(),
          novoDocumento.descricao.trim() || "",
        );
        const documentos = await documentoService.obterDocumentosPorSolicitacao(
          processoSelecionado.id,
        );
        onDocumentoAdicionado(documentos.data || []);
      }

      handleFechar();
    } catch (err) {
      alert(
        err?.response?.data?.message ||
          err?.response?.data?.detail ||
          "Erro ao adicionar documento."
      );
    } finally {
      setUploading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleFechar} maxWidth="sm" fullWidth>
      <DialogTitle>Adicionar Documento</DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Nome Do Arquivo"
              placeholder="Nome do arquivo"
              value={novoDocumento.nomeDoArquivo}
              onChange={(e) =>
                setNovoDocumento({
                  ...novoDocumento,
                  nomeDoArquivo: e.target.value,
                })
              }
              fullWidth
              required
              size="small"
              inputProps={{ maxLength: 255 }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Descrição"
              placeholder="Descrição (opcional)"
              value={novoDocumento.descricao}
              onChange={(e) =>
                setNovoDocumento({
                  ...novoDocumento,
                  descricao: e.target.value,
                })
              }
              fullWidth
              multiline
              required
              minRows={3}
              size="small"
              inputProps={{ maxLength: 500 }}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <Box sx={{ p: 2, display: "flex", gap: 2, justifyContent: "flex-end" }}>
        <Button variant="outlined" onClick={handleFechar} disabled={uploading}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAdicionarDocumento}
          disabled={uploading}
        >
          {uploading ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
          Adicionar
        </Button>
      </Box>
    </Dialog>
  );
};

export default AdicionarDocumentoModal;
